/**
 * TPD Widget Footer JavaScript
 *
 * Handles RSS feed loading and OpenWeb integration
 * Reuses existing OpenWeb pattern from recipes/reviews.js
 *
 * @package TPD_Addons
 * @since   1.0.0
 */

( function() {
	'use strict';

	// Get settings from localized script (only used for OpenWeb now).
	const settings = window.tpdOutbrainSettings || {};
	const { contentType = 'openweb', spotimId = '' } = settings;

	/**
	 * Initialize OpenWeb (Spot.im) Comments
	 * Pattern matches recipes/reviews.js implementation
	 */
	const initOpenWeb = () => {
		if ( ! spotimId ) {
			if ( window.console ) {
				console.error( 'OpenWeb: Spot ID not configured' );
			}
			return;
		}

		// Check if on single post.
		const isSinglePost =
			document.body.classList.contains( 'single-post' ) ||
			document.body.classList.contains( 'single' ) ||
			document.querySelector( 'article.post' );

		if ( ! isSinglePost ) {
			return;
		}

		// Get post data.
		const postData = getPostData();
		if ( ! postData.postId ) {
			if ( window.console ) {
				console.warn( 'OpenWeb: Could not detect post ID' );
			}
			return;
		}

		// Get container.
		const wrapper = document.querySelector( '#openweb-container-wrapper' );
		if ( ! wrapper ) {
			return;
		}

		// Create OpenWeb container.
		const container = document.createElement( 'div' );
		container.id = 'tpd-comments-container-openweb';
		container.setAttribute( 'data-spotim-module', 'conversation' );
		container.setAttribute( 'data-social-reviews', 'false' );
		container.setAttribute( 'data-post-url', postData.postUrl );
		container.setAttribute( 'data-article-tags', postData.tags );
		container.setAttribute( 'data-post-id', postData.postId );

		wrapper.appendChild( container );

		// Lazy load with Intersection Observer (same pattern as recipes).
		let tpdCommentsLoaded = false;

		( function( dom, load ) {
			const observer = new IntersectionObserver(
				function( entries ) {
					if ( entries[ 0 ].isIntersecting ) {
						observer.unobserve( dom );
						load();
					}
				},
				{
					rootMargin: '500px'
				}
			);
			observer.observe( dom );
		} )(
			container,
			function() {
				if ( ! tpdCommentsLoaded ) {
					tpdCommentsLoaded = true;

					const script = document.createElement( 'script' );
					script.src = `https://launcher.spot.im/spot/${ spotimId }`;
					script.setAttribute( 'data-spotim-module', 'spotim-launcher' );
					script.setAttribute( 'data-post-id', postData.postId );
					script.setAttribute( 'data-post-url', postData.postUrl );
					script.setAttribute( 'data-messages-count', '3' );
					script.async = true;

					container.appendChild( script );
				}
			}
		);
	};

	/**
	 * Get post data from page
	 *
	 * @return {Object} Post data.
	 */
	const getPostData = () => {
		// Try to get post ID from body class.
		let postId = null;
		const bodyClasses = document.body.className.split( ' ' );

		for ( const cls of bodyClasses ) {
			if ( cls.startsWith( 'postid-' ) ) {
				postId = cls.replace( 'postid-', '' );
				break;
			}
		}

		// Fallback: try data attributes.
		if ( ! postId ) {
			const article = document.querySelector( 'article[data-id], article[id^="post-"]' );
			if ( article ) {
				postId = article.getAttribute( 'data-id' ) || article.id.replace( 'post-', '' );
			}
		}

		// Get current URL (canonical if available).
		let postUrl = window.location.href;
		const canonical = document.querySelector( 'link[rel="canonical"]' );
		if ( canonical ) {
			postUrl = canonical.href;
		}

		// Remove staging subdomain if present.
		postUrl = postUrl.replace( 'staging.', '' );

		// Get tags.
		const tagLinks = document.querySelectorAll( '.entry-tags a, .post-tags a, .tags a, a[rel="tag"]' );
		const tags = Array.from( tagLinks )
			.map( ( a ) => a.textContent.trim() )
			.join( ', ' );

		return { postId, postUrl, tags };
	};

	// RSS feed is now handled server-side in PHP for better compatibility and performance.
	// This JavaScript file now only handles OpenWeb integration.

	/**
	 * Initialize on DOM ready
	 */
	const init = () => {
		if ( 'openweb' === contentType ) {
			initOpenWeb();
		}
		// RSS feed is handled server-side in PHP - no client-side init needed.
	};

	// Wait for DOM to be ready.
	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
